export default function calculateOrderQuanity(order) {


    const total = order.reduce((runningTotal, singleOrder) => {
        return runningTotal +  singleOrder.quality  ;
    }, 0);
    return total+0;

}
